<template>
    <div>
        <contact-header 
            :actIndex="actIndex" 
            :imgList="imgList" 
            :topStyle="topStyle" 
            :logo="logo"
            :productType="productType">
        </contact-header>
        <contact-way :wayInfo="contactInfo"></contact-way>
        <!--<contact-need></contact-need>-->
        <contact-map></contact-map>
        <contact-footer 
            :bottomNews="bottomNews"
            :bottom="bottom" 
            :bottomInfo="contactInfo"
            :productType="productType">
        </contact-footer>
    </div>
</template>

<script>
import ContactHeader from '@/components/pc/Header'
import ContactWay from '@/components/pc/ContactWay'
import ContactNeed from '@/components/pc/ContactNeed'
import ContactMap from '@/components/pc/ContactMap'
import ContactFooter from '@/components/pc/Footer'
export default {
    name: 'Contact',
    data () {
        return {
            screenStyle: {
                width: '',
                margin: "0 auto",
            },
            actIndex: 6,
            topStyle: "",
            imgList: [],
            bottom: {},
            logo: '',
            contactInfo: {},
            productType: [],
            bottomNews: []
        }
    },
    components: {
        ContactHeader,
        ContactWay,
        ContactNeed,
        ContactMap,
        ContactFooter,
    },
    mounted () {
        this.Pc_Mobile()
        this.getPageData()
        
    },
    methods: {
        _isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
        },
        Pc_Mobile () {
            if(this._isMobile()) {
                this.$router.replace('/m_contact');
            }else{
                this.$router.replace('/contact');
            }
        },
        getPageData () {
            this.$http.post('home/index/contact',null, (res) => { 
                // console.log(res.data)
                this.bottom = res.data.bottom[0]
                this.logo = this.bottom.logo
                this.topStyle = "background-image:url('"+this.$imgUrl+res.data.header[0].lxwm.replace(/\\/g,'/')+"')"
                this.contactInfo = res.data.contact[0]
                this.productType = res.data.type
                this.bottomNews = res.data.b_news
                this.$nextTick(()=>{
                })
            })
        },
    }
}
</script>

<style lang="stylus" scoped>
    
</style>


// WEBPACK FOOTER //
// src/views/pc/Contact.vue